<script>
import MainNavItem from './MainNavItem.vue'

export default {
  name: 'MainNav',

  components: {
    MainNavItem,
  },

  props: {
    navItems: Array,
    theme: {
      type: String,
      default: 'light',
    },
    dropdownTheme: {
      type: String,
      default: 'dark',
    },
    dropdownOpenId: [Number, null],
  },

  methods: {
    dropdownIsOpen (id) {
      return this.dropdownOpenId === id
    },
    openDropdown (id) {
      this.$emit('dropdown-opened', id)
    },
    closeDropdown () {
      this.$emit('dropdown-closed')
    }
  },
}
</script>

<template>
  <ul class="main-nav">
    <MainNavItem
      v-for="item in navItems"
      :key="item.id"
      tag-name="li"
      :id="item.id"
      :type="item.type"
      :title="item.title"
      :url="item.url"
      :target="item.target"
      :active="item.active"
      :children="item.children"
      :theme="theme"
      :dropdown-theme="dropdownTheme"
      :dropdown-open="dropdownIsOpen(item.id)"
      @dropdown-opened="openDropdown"
      @dropdown-closed="closeDropdown"
    />
  </ul>
</template>
